import { CdDocStates } from "../CdDocStates";
import { CardSection, Card } from "tessa/cards";
import { CdFdTaskTypes } from "../CdFdTaskTypes"

export declare class Role {
    IntID: number;
    GuidID: guid;

};

export class CdExecutiveDocumentationSharedHelper {
    static ApproverTaskStoreInfo =
        {
            TaskSignTypesList: [CdFdTaskTypes.PkSignExecutiveDocumentationAgreementTypeID
                , CdFdTaskTypes.PkSignExecutiveDocumentationAgreementWithAgreementorTypeID
                , CdFdTaskTypes.PkSignExecutiveDocumentationCoordinationAuthorSupervisionTypeID]
        }


    public static GetRoles() {
        let roles: { GuidID: guid, IntID: number, DefaultOrder: number }[] = [];
        roles.push({ IntID: 1, GuidID: '3c70cb9c-b30a-4d97-aa7e-6d1727ba3acf', DefaultOrder: 0 }); // Представитель лица, выполнившего работы, подлежащие освидетельствованию
        roles.push({ IntID: 2, GuidID: '64438fd3-6ca4-4896-88df-82a31f3f66d8', DefaultOrder: 1 }); // Представитель лица, осуществляющего строительство
        roles.push({ IntID: 3, GuidID: 'd690d0ae-20c8-424d-8899-f6d1bf055c56', DefaultOrder: 2 }); // Представитель лица, осуществляющего строительство, по вопросам строительного контроля (специалист по организации строительства)
        roles.push({ IntID: 4, GuidID: 'b29d7703-fd65-42bd-a561-004932065094', DefaultOrder: 5 }); // Представитель лица, осуществляющего подготовку проектной документации
        roles.push({ IntID: 5, GuidID: '08d227fa-4146-428f-9b23-b6f5714bbe26', DefaultOrder: 3 }); // Представитель застройщика (технического заказчика, эксплуатирующей организации или регионального оператора) по вопросам строительного контроля
        roles.push({ IntID: 6, GuidID: '7a31979d-70f5-4079-8a2f-e5ee13d8ea51', DefaultOrder: 6 }); // Представители иных лиц (эксплуатирующая организация)
        roles.push({ IntID: 7, GuidID: '35a9c17c-fd84-4510-a779-d854bf84a291', DefaultOrder: 7 }); // Инженер ПТО     
        roles.push({ IntID: 9, GuidID: '35a9c17c-fd84-4510-a779-d854bf84a291', DefaultOrder: 8 }), // Представитель застройщика   
            roles.push({ IntID: 8, GuidID: '35a9c17c-fd84-4510-a779-d854bf84a291', DefaultOrder: 4 }); // Инженер авторского надзора   
        return roles;
    }


    // Получить ID роли по состоянию (используется для синхронизации согласующий в таблице и задании)
    public static GetRoleID(docState: number | undefined | null) {
        if (!docState) {
            return -1;
        }

        if (docState === CdDocStates.OnApprovalSubcontractor.id ||
            docState === CdDocStates.OnSigningSubcontractor.id) {
            return 0;
        }
        else if (docState === CdDocStates.OnApprovalContractor.id ||
            docState === CdDocStates.OnSigningContractor.id) {
            return 1;
        }
        else if (docState === CdDocStates.OnApprovalGPExecutorWorks.id ||
            docState === CdDocStates.OnSigningGPExecutorWorks.id) {
            return 2;
        }
        else if (docState === CdDocStates.OnApprovalGP.id ||
            docState === CdDocStates.OnSigningGP.id) {
            return 3;
        }
        else if (docState === CdDocStates.OnApprovalAuthorSupervision.id ||
            docState === CdDocStates.OnSigningAuthorSupervision.id) {
            return 5;
        }
        else if (docState === CdDocStates.OnApprovalCustomer.id ||
            docState === CdDocStates.OnSigningCustomer.id) {
            return 4;
        }
        else if (docState === CdDocStates.OnApprovalOperatingOrganization.id ||
            docState === CdDocStates.OnSigningOperatingOrganization.id) {
            return 6;
        }
        else if (docState === CdDocStates.OnApprovalASEngeneer.id)
            return 8;
        else {
            return -1;
        }
    }



    /** Получить ИД шаблона файла */
    public static GetCurrentTemplateFileRowID(card: Card) {
        let ediSection: CardSection | undefined = card.sections.tryGet('PkExecutiveDocumentationInfo');
        if (!ediSection) return null;
        let templateFileRowID: guid | undefined = ediSection.fields.tryGet('TemplateFileRowID');
        if (!templateFileRowID) return null;
        return templateFileRowID;
    }
}
